import React from "react";

export default function Line() {
  return <div className="h-[1px] md:w-[103px] w-[50px] bg-gray-300"></div>;
}
